export function applyPaymentEvent(event) {
    switch (event.kind) {
        case 'ready':
            return { phase: 'ready' };
        case 'buttonPressed':
            return { phase: 'authorizing' };
        case 'unsupported':
            return { phase: 'unsupported' };
        case 'quoteExpired':
            return { phase: 'quote_expired' };
        case 'cancelled':
            return { phase: 'cancelled' };
        case 'challenge':
            return { phase: 'challenge_required', url: event.payload.url };
        case 'complete':
            return transactionContinuation(event.payload.transaction);
        case 'error': {
            const kind = 'kind' in event.payload ? event.payload.kind : event.payload.code;
            return {
                phase: kind === 'oneTapApplePaySecondFactorRequired'
                    ? 'second_factor_required'
                    : kind === 'quoteExpired' || kind === 'invalidQuote'
                        ? 'quote_expired'
                        : 'submission_unknown',
            };
        }
    }
}
export function applyChallengeEvent(event) {
    switch (event.kind) {
        case 'ready':
            return { phase: 'ready' };
        case 'error':
            return { phase: 'submission_unknown' };
        case 'cancelled':
            if (event.payload.flow === 'buy') {
                return event.payload.transactionId
                    ? { phase: 'reconciling', transactionId: event.payload.transactionId }
                    : { phase: 'submission_unknown' };
            }
            return { phase: 'cancelled' };
        case 'complete': {
            const result = event.payload;
            // Payment completion must reconcile even if credentials also changed.
            if (result.flow === 'buy')
                return transactionContinuation(result.transaction);
            if (result.sessionUpgraded)
                return { phase: 'session_refresh_required' };
            if (result.flow === 'identity')
                return { phase: 'requote_required' };
            return {
                phase: result.status === 'upgraded'
                    ? 'requote_required'
                    : result.status === 'rejected'
                        ? 'connection_required'
                        : 'verification_pending',
            };
        }
    }
}
function transactionContinuation(transaction) {
    if (transaction.id)
        return { phase: 'reconciling', transactionId: transaction.id };
    return { phase: transaction.status === 'failed' ? 'rejected' : 'submission_unknown' };
}
